export const STARTED = 'Started';
export const CREATED = 'Created';
export const SUBMITTED = 'Submitted';
export const COMPLETED = 'Completed';
export const ERRORED = 'Errored';